// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"QI-z","smallCardRow":"RI-z","largeCardRow":"SI-z","productSearchRow":"TI-z","curatedRow":"UI-z"};